module.exports = __webpack_public_path__ + "img/logo.a43cfc66.png";